import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { TableCell, TableRow, TableHead, Button } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';

const FinancialProductWarrantiesTableHead = ({ canWrite, onAdd, isSaved }) => {
  const { t } = useTranslation();

  return (
    <TableHead>
      <TableRow>
        <TableCell style={{ width: '30%', fontWeight: 'bold' }}>{t('FinancialProduct.Details.Warranties.WarrantyType')}</TableCell>
        <TableCell style={{ width: '10%', fontWeight: 'bold' }}>{t('FinancialProduct.Details.Warranties.Quantity')}</TableCell>
        <TableCell style={{ width: '30%', fontWeight: 'bold' }}>{t('FinancialProduct.Details.Warranties.QuantityType')}</TableCell>
        <TableCell style={{ width: '10%', fontWeight: 'bold' }}>{t('FinancialProduct.Details.Warranties.Mandatory')}</TableCell>
        <TableCell style={{ width: '20%', fontWeight: 'bold' }} align='right'>
          <Button color='primary' variant='contained' startIcon={<AddIcon />} disabled={!isSaved || !canWrite} onClick={onAdd}>
            {t('Add')}
          </Button>
        </TableCell>
      </TableRow>
    </TableHead>
  );
};

FinancialProductWarrantiesTableHead.propTypes = {
  canWrite: PropTypes.bool.isRequired,
  onAdd: PropTypes.func.isRequired,
  isSaved: PropTypes.bool.isRequired
};

export default FinancialProductWarrantiesTableHead;
